var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoIcon = function SvgLogoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 66 64"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 53,
    x: 0.792,
    y: 10.534,
    fill: "#143575",
    rx: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 53,
    x: 0.792,
    y: 10.534,
    stroke: "#fff",
    rx: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FD0",
    d: "M35.312 25.227c.157.891.515 1.223 1.383 1.07l4.301-.758c.868-.153 1.131-.595.974-1.486l-.276-1.57c-.644-3.65-3.598-6.85-11.248-5.5-7.651 1.348-9.166 5.336-8.522 8.986l.434 2.46c.434 2.462 2.59 4.534 4.842 4.967l6.359 1.243c1.677.316 3.789.689 4.058 2.217l.15.85c.344 1.953-1.182 2.964-3.209 3.322-2.027.357-3.767-.081-4.111-2.032l-.337-1.909c-.157-.89-.515-1.223-1.383-1.07l-4.302.758c-.868.154-1.131.595-.974 1.486l.502 2.845c.643 3.65 3.884 6.799 11.662 5.427 7.774-1.37 9.662-5.424 9.019-9.074l-.532-3.013c-.554-3.142-3.053-4.977-6.3-5.497l-7.375-1.194c-.485-.09-1.442-.445-1.645-1.593l-.075-.425c-.344-1.953.895-2.914 2.795-3.25 1.904-.335 3.353.152 3.698 2.105z"
  })));
};
export default SvgLogoIcon;